import React from 'react';

import { FooterBottomWrapper } from './FooterBottom.styles';

export const FooterBottom = () => (
  <FooterBottomWrapper className="footer__bottom">©2019 mBank S.A.</FooterBottomWrapper>
);
